// @flow
import * as R from "ramda"

import Price from "common/records/Price"
import type {
  PriorityBoarding,
  PriorityBoardingInput,
  PriorityBoardingPriceInfoInput,
} from "booking/services/additionalServices/services/priorityBoarding/services/types"

const getPriceFromPriceInfo = (priceInfo: PriorityBoardingPriceInfoInput): Price =>
  new Price({
    amount: Number(priceInfo.amount),
    base: Number(priceInfo.base),
    currency: priceInfo.currency,
    merchant: Number(priceInfo.merchant),
    service: Number(priceInfo.service),
    serviceFlat: Number(priceInfo.service_flat),
  })

const mapperPriorityBoarding = ({ type, data }: PriorityBoardingInput): PriorityBoarding => ({
  type,
  data: R.map(
    x => ({
      isPossible: x.is_possible,
      price: getPriceFromPriceInfo(x.price_info),
    }),
    data,
  ),
  enabled: true,
  ordered: {},
})

export default mapperPriorityBoarding
